import { useMobileDrawer } from '../../contexts/MobileDrawerContext';

/** Backdrop shown when the mobile drawer is open. Click closes the drawer. */
export function Scrim() {
  const { isMobile, isOpen, close } = useMobileDrawer();
  if (!isMobile || !isOpen) return null;
  return (
    <div
      className="scrim"
      onClick={close}
      role="presentation"
      aria-hidden="true"
    />
  );
}
